module.exports = __webpack_public_path__ + "build/img/christmas.a0379308.jpg";